import { render, staticRenderFns } from "./ResBrand.vue?vue&type=template&id=303dae86&scoped=true"
import script from "./ResBrand.vue?vue&type=script&lang=js"
export * from "./ResBrand.vue?vue&type=script&lang=js"
import style0 from "./ResBrand.vue?vue&type=style&index=0&id=303dae86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303dae86",
  null
  
)

export default component.exports